import { useState } from "react";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import ShopMarkerSmall from '../RouteMap/ShopMarkerSmall';
import EndingLocationMarkerSmall from '../RouteMap/EndingLocationMarkerSmall';

const RouteViewMapLegend = () => {
  const [legendOpen, setLegendOpen] = useState(true);

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '20px',
        right: '10px',
        backgroundColor: 'white',
        padding: '10px',
        borderRadius: '12px',
        boxShadow: '0 0 10px rgba(0,0,0,0.1)',
        zIndex: 1,
        fontSize: '12px',
        minWidth: '150px'
      }}
    >
      <div
        style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', userSelect: 'none' }}
        onClick={() => setLegendOpen(!legendOpen)}
      >
        {legendOpen ? (
          <DownOutlined style={{ fontSize: '12px' }} />
        ) : (
          <RightOutlined style={{ fontSize: '12px' }} />
        )}
        <span style={{ fontWeight: 600 }}>Legend</span>
      </div>
      {legendOpen && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10, marginTop: 10 }}>
            <div style={{
              position: 'relative',
              width: '16px',
              height: '24px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginRight: '8px'
            }}>
              <div style={{
                width: '16px',
                height: '16px',
                backgroundColor: '#FFCABD',
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid #FF5C35',
                zIndex: 2
              }}>
                <span style={{ color: '#FF5C35', fontWeight: 'bold', fontSize: 10 }}>#</span>
              </div>
              <div style={{
                width: '10px',
                height: '10px',
                backgroundColor: '#FFCABD',
                clipPath: 'polygon(50% 100%, 0 0, 100% 0)',
                marginTop: '-3px',
                boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
                zIndex: 1
              }} />
            </div>
            <span>Added Job</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
            <ShopMarkerSmall />
            <span>Starting Location</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
            <EndingLocationMarkerSmall />
            <span>Alt. Ending Location</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
            <div style={{
              width: '20px',
              height: '3px',
              backgroundColor: '#FF5C35',
              marginRight: '8px',
              borderRadius: '2px'
            }} />
            <span>Current Route</span>
          </div>
        </>
      )}
    </div>
  );
};

export default RouteViewMapLegend;